export interface CropDataInput {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  imageWidth?: number;
  imageHeight?: number;
}

export default class CropData {
  private xValue!: number;
  private yValue!: number;
  private widthValue!: number;
  private heightValue!: number;
  private imageWidthValue!: number;
  private imageHeightValue!: number;

  constructor(cropData: CropDataInput = {}) {
    this.x = cropData.x ?? 0;
    this.y = cropData.y ?? 0;
    this.width = cropData.width ?? 0;
    this.height = cropData.height ?? 0;
    this.imageWidth = cropData.imageWidth ?? 0;
    this.imageHeight = cropData.imageHeight ?? 0;
  }

  get x(): number {
    return this.xValue;
  }

  set x(value: number) {
    this.xValue = Math.round(value);
  }

  get y(): number {
    return this.yValue;
  }

  set y(value: number) {
    this.yValue = Math.round(value);
  }

  get width(): number {
    return this.widthValue;
  }

  set width(value: number) {
    this.widthValue = Math.round(value);
  }

  get height(): number {
    return this.heightValue;
  }

  set height(value: number) {
    this.heightValue = Math.round(value);
  }

  get imageWidth(): number {
    return this.imageWidthValue;
  }

  set imageWidth(value: number) {
    this.imageWidthValue = Math.round(value);
  }

  get imageHeight(): number {
    return this.imageHeightValue;
  }

  set imageHeight(value: number) {
    this.imageHeightValue = Math.round(value);
  }

  /**
   * Checks whether current cropData defines original image dimensions
   */
  isMaxCropped(): boolean {
    const thresholdPx = 1;
    const deltaWidth = Math.abs(this.width - this.imageWidth);
    const deltaHeight = Math.abs(this.height - this.imageHeight);

    return this.x <= thresholdPx && this.y <= thresholdPx
      && deltaWidth <= thresholdPx
      && deltaHeight <= thresholdPx;
  }

  toObject(): CropDataInput {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      imageWidth: this.imageWidth,
      imageHeight: this.imageHeight,
    };
  }
}